import { buildNewestSet, calculateNewnessPriority } from 'src/components/SetsConfigDetails/newnessSet';

interface RawSetsConfigSummary {
    productKey: string;
    name: string;
    locale: string;
    modifiedDate: string;
    modifiedBy: string;
}

const RAW_SETS_CONFIGS: RawSetsConfigSummary[] = [
    {
        productKey: 'PRD-8K2N4QRT',
        name: 'standard-business-cards holiday cheer',
        locale: 'en-us',
        modifiedDate: '2026-02-01T08:00:00Z',
        modifiedBy: 'jane.chen@vistaprint.com',
    },
    {
        productKey: 'PRD-2X9F7MWL',
        name: 'premium-business-cards greenery',
        locale: 'en-us',
        modifiedDate: '2026-03-04T09:07:13Z',
        modifiedBy: 'alex.novak@vistaprint.com',
    },
    {
        productKey: 'PRD-5T3B8VQK',
        name: 'folded-cards minimalist',
        locale: 'en-us',
        modifiedDate: '2026-04-07T10:14:26Z',
        modifiedBy: 'priya.dubois@vistaprint.com',
    },
    {
        productKey: 'PRD-9M4D2LXR',
        name: 'flat-cards spring floral',
        locale: 'en-us',
        modifiedDate: '2026-05-10T11:21:39Z',
        modifiedBy: 'marcus.larsen@vistaprint.com',
    },
    {
        productKey: 'PRD-7H6K1PZC',
        name: 'postcards bold geometric',
        locale: 'en-us',
        modifiedDate: '2026-06-13T12:28:52Z',
        modifiedBy: 'elena.patel@vistaprint.com',
    },
    {
        productKey: 'PRD-3W8N5TFQ',
        name: 'letterhead classic script',
        locale: 'en-us',
        modifiedDate: '2026-07-16T13:35:05Z',
        modifiedBy: 'sam.rossi@vistaprint.com',
    },
    {
        productKey: 'PRD-6R2Y9BLM',
        name: 'envelopes watercolor',
        locale: 'en-us',
        modifiedDate: '2026-02-19T14:42:18Z',
        modifiedBy: 'nina.reyes@vistaprint.com',
    },
    {
        productKey: 'PRD-1Q7X4KDN',
        name: 'banners modern typography',
        locale: 'en-us',
        modifiedDate: '2026-03-22T15:49:31Z',
        modifiedBy: 'chris.garcia@vistaprint.com',
    },
    {
        productKey: 'PRD-4V9C6RMT',
        name: 'yard-signs vintage charm',
        locale: 'en-us',
        modifiedDate: '2026-04-25T16:56:44Z',
        modifiedBy: 'olivia.osei@vistaprint.com',
    },
    {
        productKey: 'PRD-8N3F2WQL',
        name: 'table-covers tropical',
        locale: 'en-us',
        modifiedDate: '2026-05-01T17:03:57Z',
        modifiedBy: 'ravi.kim@vistaprint.com',
    },
    {
        productKey: 'PRD-5D7K9XRB',
        name: 'brochures wedding elegance',
        locale: 'en-us',
        modifiedDate: '2026-06-04T08:10:10Z',
        modifiedBy: 'jane.chen@vistaprint.com',
    },
    {
        productKey: 'PRD-2M8T4VLN',
        name: 'flyers corporate blue',
        locale: 'en-us',
        modifiedDate: '2026-07-07T09:17:23Z',
        modifiedBy: 'alex.novak@vistaprint.com',
    },
    {
        productKey: 'PRD-9F6Q3KWD',
        name: 'posters rustic wood',
        locale: 'en-gb',
        modifiedDate: '2026-02-10T10:24:36Z',
        modifiedBy: 'priya.dubois@vistaprint.com',
    },
    {
        productKey: 'PRD-6C1R8NLX',
        name: 'calendars neon pop',
        locale: 'en-us',
        modifiedDate: '2026-03-13T11:31:49Z',
        modifiedBy: 'marcus.larsen@vistaprint.com',
    },
    {
        productKey: 'PRD-3B9M5TQK',
        name: 'notebooks pastel dreams',
        locale: 'en-us',
        modifiedDate: '2026-04-16T12:38:02Z',
        modifiedBy: 'elena.patel@vistaprint.com',
    },
    {
        productKey: 'PRD-7L4X2DVN',
        name: 'mugs black and white',
        locale: 'en-us',
        modifiedDate: '2026-05-19T13:45:15Z',
        modifiedBy: 'sam.rossi@vistaprint.com',
    },
    {
        productKey: 'PRD-1K8W6RMF',
        name: 'water-bottles gold foil',
        locale: 'en-us',
        modifiedDate: '2026-06-22T14:52:28Z',
        modifiedBy: 'nina.reyes@vistaprint.com',
    },
    {
        productKey: 'PRD-4N2Q9BLT',
        name: 'tote-bags botanical',
        locale: 'fr-fr',
        modifiedDate: '2026-07-20T15:59:41Z',
        modifiedBy: 'chris.garcia@vistaprint.com',
    },
    {
        productKey: 'PRD-8R5V3XKD',
        name: 't-shirts art deco',
        locale: 'en-us',
        modifiedDate: '2026-02-01T16:06:54Z',
        modifiedBy: 'olivia.osei@vistaprint.com',
    },
    {
        productKey: 'PRD-2T7M6QWN',
        name: 'stickers kids birthday',
        locale: 'en-us',
        modifiedDate: '2026-03-04T17:13:07Z',
        modifiedBy: 'ravi.kim@vistaprint.com',
    },
    {
        productKey: 'PRD-9X4K1LRB',
        name: 'labels graduation',
        locale: 'fr-fr',
        modifiedDate: '2026-04-07T08:20:20Z',
        modifiedBy: 'jane.chen@vistaprint.com',
    },
    {
        productKey: 'PRD-6D8N3VMT',
        name: 'invitations new year',
        locale: 'en-us',
        modifiedDate: '2026-05-10T09:27:33Z',
        modifiedBy: 'alex.novak@vistaprint.com',
    },
    {
        productKey: 'PRD-3F5Q7RKL',
        name: 'save-the-dates valentines day',
        locale: 'en-us',
        modifiedDate: '2026-06-13T10:34:46Z',
        modifiedBy: 'priya.dubois@vistaprint.com',
    },
    {
        productKey: 'PRD-7B2X9WDN',
        name: 'holiday-cards mothers day',
        locale: 'en-us',
        modifiedDate: '2026-07-16T11:41:59Z',
        modifiedBy: 'marcus.larsen@vistaprint.com',
    },
    {
        productKey: 'PRD-1M6T4KQR',
        name: 'thank-you-cards fathers day',
        locale: 'en-us',
        modifiedDate: '2026-02-19T12:48:12Z',
        modifiedBy: 'elena.patel@vistaprint.com',
    },
    {
        productKey: 'PRD-5N9F2VLX',
        name: 'door-hangers back to school',
        locale: 'en-us',
        modifiedDate: '2026-03-22T13:55:25Z',
        modifiedBy: 'sam.rossi@vistaprint.com',
    },
    {
        productKey: 'PRD-8Q3K6RMB',
        name: 'rack-cards grand opening',
        locale: 'en-us',
        modifiedDate: '2026-04-25T14:02:38Z',
        modifiedBy: 'nina.reyes@vistaprint.com',
    },
    {
        productKey: 'PRD-4X7D1NWT',
        name: 'presentation-folders sale event',
        locale: 'en-gb',
        modifiedDate: '2026-05-01T15:09:51Z',
        modifiedBy: 'chris.garcia@vistaprint.com',
    },
    {
        productKey: 'PRD-2R8M5QLK',
        name: 'notepads real estate',
        locale: 'en-us',
        modifiedDate: '2026-06-04T16:16:04Z',
        modifiedBy: 'olivia.osei@vistaprint.com',
    },
    {
        productKey: 'PRD-6V3B9TXN',
        name: 'luggage-tags restaurant menu',
        locale: 'en-us',
        modifiedDate: '2026-07-07T17:23:17Z',
        modifiedBy: 'ravi.kim@vistaprint.com',
    },
    {
        productKey: 'PRD-9K1F4RWD',
        name: 'magnets fitness studio',
        locale: 'en-us',
        modifiedDate: '2026-02-10T08:30:30Z',
        modifiedBy: 'jane.chen@vistaprint.com',
    },
    {
        productKey: 'PRD-3T6N8QLM',
        name: 'car-magnets salon beauty',
        locale: 'en-gb',
        modifiedDate: '2026-03-13T09:37:43Z',
        modifiedBy: 'alex.novak@vistaprint.com',
    },
    {
        productKey: 'PRD-7X2D5VKB',
        name: 'window-clings photography showcase',
        locale: 'en-us',
        modifiedDate: '2026-04-16T10:44:56Z',
        modifiedBy: 'priya.dubois@vistaprint.com',
    },
    {
        productKey: 'PRD-1B9Q3RMT',
        name: 'vinyl-banners nonprofit outreach',
        locale: 'en-us',
        modifiedDate: '2026-05-19T11:51:09Z',
        modifiedBy: 'marcus.larsen@vistaprint.com',
    },
    {
        productKey: 'PRD-5F6K7NWX',
        name: 'retractable-banners farmers market',
        locale: 'fr-fr',
        modifiedDate: '2026-06-22T12:58:22Z',
        modifiedBy: 'elena.patel@vistaprint.com',
    },
    {
        productKey: 'PRD-8M4T2LDR',
        name: 'step-repeat-banners coffee shop',
        locale: 'en-us',
        modifiedDate: '2026-07-19T13:05:35Z',
        modifiedBy: 'sam.rossi@vistaprint.com',
    },
    {
        productKey: 'PRD-2N7X9QKB',
        name: 'photo-books bakery sweets',
        locale: 'en-us',
        modifiedDate: '2026-02-01T14:12:48Z',
        modifiedBy: 'nina.reyes@vistaprint.com',
    },
    {
        productKey: 'PRD-6R3V8TML',
        name: 'greeting-cards law firm',
        locale: 'en-us',
        modifiedDate: '2026-03-04T15:19:01Z',
        modifiedBy: 'chris.garcia@vistaprint.com',
    },
    {
        productKey: 'PRD-9D5K1FWN',
        name: 'rubber-stamps tech startup',
        locale: 'en-us',
        modifiedDate: '2026-04-07T16:26:14Z',
        modifiedBy: 'olivia.osei@vistaprint.com',
    },
    {
        productKey: 'PRD-4Q8B6RXT',
        name: 'pens construction crew',
        locale: 'en-us',
        modifiedDate: '2026-05-10T17:33:27Z',
        modifiedBy: 'ravi.kim@vistaprint.com',
    },
    {
        productKey: 'PRD-1L2N7VMK',
        name: 'keychains automotive shop',
        locale: 'en-us',
        modifiedDate: '2026-06-13T08:40:40Z',
        modifiedBy: 'jane.chen@vistaprint.com',
    },
    {
        productKey: 'PRD-7T9F3QDB',
        name: 'phone-cases pet grooming',
        locale: 'en-us',
        modifiedDate: '2026-07-16T09:47:53Z',
        modifiedBy: 'alex.novak@vistaprint.com',
    },
    {
        productKey: 'PRD-3X6M4RWL',
        name: 'face-masks travel agency',
        locale: 'en-us',
        modifiedDate: '2026-02-19T10:54:06Z',
        modifiedBy: 'priya.dubois@vistaprint.com',
    },
    {
        productKey: 'PRD-8K1D9NQT',
        name: 'aprons wellness spa',
        locale: 'en-us',
        modifiedDate: '2026-03-22T11:01:19Z',
        modifiedBy: 'marcus.larsen@vistaprint.com',
    },
    {
        productKey: 'PRD-5V7B2XLM',
        name: 'tumblers winter frost',
        locale: 'en-us',
        modifiedDate: '2026-04-25T12:08:32Z',
        modifiedBy: 'elena.patel@vistaprint.com',
    },
    {
        productKey: 'PRD-2F4Q8RKN',
        name: 'coasters summer bbq',
        locale: 'en-us',
        modifiedDate: '2026-05-01T13:15:45Z',
        modifiedBy: 'sam.rossi@vistaprint.com',
    },
    {
        productKey: 'PRD-9N6T3WDB',
        name: 'signage autumn harvest',
        locale: 'en-gb',
        modifiedDate: '2026-06-04T14:22:58Z',
        modifiedBy: 'nina.reyes@vistaprint.com',
    },
];

// Full culture sets for the regions defined in config.groupedLocales, so some mock configs
// fully cover a region and render the collapsed region label ("NA", "ANZS").
const NORTH_AMERICA = ['en-ca', 'en-us', 'es-us', 'fr-ca'];
const ANZS = ['en-au', 'en-nz', 'en-sg'];

// Spreads each mock entry into locale groups covering the display cases: single culture, partial
// region, a fully covered region, a region plus leftover cultures, and a "+N" overflow.
const buildMockCultureGroups = (
    primaryLocale: string,
    index: number,
): Models.IngestConfigApi.SetsConfigs.CultureGroup[] => {
    switch (index % 6) {
        case 0:
            return [{ name: 'North America', cultures: NORTH_AMERICA }];
        case 1:
            return [
                { name: 'North America', cultures: NORTH_AMERICA },
                { name: 'Europe', cultures: ['en-ie'] },
            ];
        case 2:
            return [
                { name: 'North America', cultures: NORTH_AMERICA },
                { name: 'Europe', cultures: ['en-ie', 'es-es'] },
            ];
        case 3:
            return [
                { name: 'North America', cultures: NORTH_AMERICA },
                { name: 'ANZS', cultures: ANZS },
            ];
        case 4:
            return [{ name: 'Primary', cultures: [primaryLocale, 'en-au'] }];
        default:
            return [{ name: 'Default', cultures: [primaryLocale] }];
    }
};

export const MOCK_SETS_CONFIGS: Models.IngestConfigApi.SetsConfigs.SetsConfigSummary[] = RAW_SETS_CONFIGS.map(
    (entry, index) => ({
        id: entry.productKey,
        productKey: entry.productKey,
        productName: entry.name,
        modifiedDate: entry.modifiedDate,
        modifiedBy: entry.modifiedBy,
        cultureGroups: buildMockCultureGroups(entry.locale, index),
        isEnabled: index % 5 !== 0,
    }),
);

const MOCK_REQUEST_DELAY_MS = 350;

const delay = (): Promise<void> => new Promise((resolve) => {
    setTimeout(resolve, MOCK_REQUEST_DELAY_MS);
});

// Full configs created through the modal this session, so the details page and the
// "already exists" guard reflect them without a live backend.
const createdConfigs = new Map<string, Models.IngestConfigApi.SetsConfigs.ProductSetsConfig>();

const findSummary = (
    productKey: string,
): Models.IngestConfigApi.SetsConfigs.SetsConfigSummary | undefined => MOCK_SETS_CONFIGS
    .find((setsConfig) => setsConfig.productKey.toUpperCase() === productKey.toUpperCase());

export async function getMockSetsConfigsPage(
    search: App.SetsConfigs.Search,
    offset: number,
    limit: number,
): Promise<Models.PageResult<Models.IngestConfigApi.SetsConfigs.SetsConfigSummary>> {
    const searchTerm = search.searchTerm?.toLowerCase().trim();
    const filtered = searchTerm
        ? MOCK_SETS_CONFIGS.filter((setsConfig) => (
            setsConfig.productKey.toLowerCase().includes(searchTerm)
            || setsConfig.productName.toLowerCase().includes(searchTerm)
        ))
        : MOCK_SETS_CONFIGS;

    await delay();

    return {
        results: filtered.slice(offset, offset + limit),
        offset,
        limit,
        total: filtered.length,
    };
}

// Sample sets used to seed the first locale group of a freshly-derived rich mock config, so the
// details page has meaningful set data to render instead of an empty list.
const HOLIDAY_SAMPLE_SETS: Models.SetsPlayground.SetDefinition[] = [
    {
        name: 'Holiday anchors',
        priority: 10,
        distribution: { type: 'probability', part: 0.2, offset: 0 },
        ranking: {
            type: 'inline',
            designConceptIds: ['dc-snowy-pines', 'dc-gold-joy'],
            elementFilters: [],
        },
    },
    {
        name: 'Greenery',
        priority: 20,
        distribution: { type: 'backpressure', part: 0.15, offset: 0 },
        ranking: { type: 'semantic', keywordSearchPhrase: 'greenery' },
    },
];

// Builds a rich, editable locale group from the (thin) summary group shape. Only the first group
// gets a holiday window and sample sets, so a config with multiple groups still shows the "always
// active" default case alongside a seeded one.
const buildRichLocaleGroup = (
    group: Models.IngestConfigApi.SetsConfigs.CultureGroup,
    isFirst: boolean,
): Models.IngestConfigApi.SetsConfigs.SetsConfigCultureGroup => {
    const sampleSets = isFirst ? HOLIDAY_SAMPLE_SETS.map((set) => ({ ...set })) : [];
    const sets = isFirst ? [...sampleSets, buildNewestSet(14, calculateNewnessPriority(sampleSets))] : sampleSets;

    return {
        name: group.name ?? group.cultures.join(', '),
        cultures: group.cultures,
        notes: isFirst ? 'Holiday curation' : '',
        startDate: isFirst ? '2026-11-01' : null,
        endDate: isFirst ? '2026-12-26' : null,
        newnessEnabled: false,
        newnessLookbackDays: null,
        newnessDistribution: null,
        sets,
    };
};

export async function getMockSetsConfig(
    productKey: string,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig | null> {
    await delay();

    const created = createdConfigs.get(productKey.toUpperCase());

    if (created) {
        return created;
    }

    const summary = findSummary(productKey);

    if (!summary) {
        return null;
    }

    return {
        productKey: summary.productKey,
        productName: summary.productName,
        cultureGroups: summary.cultureGroups.map((group, index) => buildRichLocaleGroup(group, index === 0)),
        modifiedDate: summary.modifiedDate,
        modifiedBy: summary.modifiedBy ?? 'unknown',
        isEnabled: summary.isEnabled,
    };
}

export async function createMockSetsConfig(
    productKey: string,
    name: string,
    modifiedBy: string,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig> {
    await delay();

    if (createdConfigs.has(productKey.toUpperCase()) || findSummary(productKey)) {
        throw new Error(`A sets config already exists for ${productKey}.`);
    }

    const modifiedDate = new Date().toISOString();
    const config: Models.IngestConfigApi.SetsConfigs.ProductSetsConfig = {
        productKey,
        productName: name,
        cultureGroups: [],
        modifiedDate,
        modifiedBy,
        isEnabled: false,
    };

    createdConfigs.set(productKey.toUpperCase(), config);
    MOCK_SETS_CONFIGS.unshift({
        id: productKey,
        productKey,
        productName: name,
        cultureGroups: [],
        modifiedDate,
        modifiedBy,
        isEnabled: false,
    });

    return config;
}

export async function updateMockSetsConfig(
    productKey: string,
    config: Models.IngestConfigApi.SetsConfigs.ProductSetsConfig,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig> {
    await delay();

    const updated: Models.IngestConfigApi.SetsConfigs.ProductSetsConfig = {
        ...config,
        modifiedDate: new Date().toISOString(),
    };

    createdConfigs.set(productKey.toUpperCase(), updated);

    return updated;
}

export async function deleteMockSetsConfig(productKey: string): Promise<void> {
    await delay();

    createdConfigs.delete(productKey.toUpperCase());

    const index = MOCK_SETS_CONFIGS.findIndex(
        (setsConfig) => setsConfig.productKey.toUpperCase() === productKey.toUpperCase(),
    );

    if (index !== -1) {
        MOCK_SETS_CONFIGS.splice(index, 1);
    }
}
